import React, { Component } from 'react';
import { connect } from "react-redux";
import { Select, Col, Table } from 'antd';
import 'antd/dist/antd.css';


const { Option } = Select;
const format = 'h:mm a';

class GateErrorLog extends Component {
    constructor(props){
        super(props);
        this.state = {
            logs: [],
            loading: true
        }
    }
    render() {
        const { gate } = this.props;
        let errors = gate.errors ?? [];

        if(errors.length === 0) 
            return (
                <div className="container gateDetail">
                    <div className="row" style={{marginTop: "25px", marginBottom: "0"}}>
                        <div className="col s6">
                            <div className="col s12">
                                No Errors yet.
                            </div>
                        </div>
                    </div>
                </div>
            );

        const columns = [
            {
                title: 'Date',
                dataIndex: 'datetime',
                width: '10%',
                key: 'date'
            },
            {
                title: 'Code',
                dataIndex: 'code',
                width: '10%',
                key: 'code'
            },
            {
                title: 'Summary',
                dataIndex: 'summary',
                width: '80%',
                key: 'summary'
            },
        ];

        errors = errors.map((error, i) => {
            error.key = i;
            return error;
        });

        return (
            <div className="col s6">
                <Col span={24}>
                    <Table
                        columns={columns}
                        dataSource={errors}
                        rowKey={errors => errors.key}
                    />
                </Col>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        gate:    state.gate.gate,
    }
}

// const mapDispatchToProps = (dispatch) => {
//     return {
//         GetGateEvents: (gate_id) => dispatch(GetGateEvents(gate_id)),
//     }
// }

export default connect(mapStateToProps)(GateErrorLog);
